export const MIDNIGHT_BLUE = '#2c3e50'
export const ASPHAULT = '#34495e'
export const CARROT = '#e67e22'
export const CLOUDS = '#ecf0f1'
export const SILVER = '#bdc3c7'
export const ASBESTOS = '#7f8c8d'
export const NEPHRITIS = '#27ae60'
export const BELIZ = '#2980b9'
export const AMETHYST = '#9b59b6'
export const WISTERIA = '#8e44ad'



// WEBPACK FOOTER //
// ./src/utils/colors.js